import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/694a8bcba8d625001444a89b_1783405270822_ff30b3df/techaero_platform/node_modules/next/dist/client/link.js");
